// Slow editorial marquee ribbon.
export function Marquee({ items, className = "", itemClassName = "", separator = "·" }) {
  const row = (
    <div className="flex shrink-0 items-center gap-24 pr-24">
      {items.map((item, i) => (
        <span key={i} className={`flex items-center gap-24 whitespace-nowrap ${itemClassName}`}>
          <span>{item}</span>
          <span aria-hidden="true" className="opacity-40">{separator}</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {row}
        {row}
      </div>
    </div>
  );
}
